/**

Shared code for localization.
This is a placeholder class and needs additional work to load the translation table JSON.

Converts text ID values to a localized string.
Converts date objects or moment object to localized viewable string and back.
Converts numbers to localized values.

Converts measurements (height, weight, etc) to viewable units.

@category Localization
*/
export class Localizer
{
    errorFieldMissing = "This field is required and may not be left empty.";
    errorPatternFail = "The information in this field is not in the correct format.";
    errorRangeFail = "The value entered is not within the valid range.";
    errorEqualTo = "The value must be equal to ";

    // ISO Language code ISO-639 2 digit
    lang: string = "en";

    // ISO country code ISO-3166 2 digit
    country: string = "us";

    static _instance: Localizer | undefined = undefined;

    constructor()
    {
    }

    /*
    Return a reference to a single instance of this class
    */
    public static Instance(): Localizer
    {
        if (!Localizer._instance)
        {
            Localizer._instance = new Localizer();
        }

        return Localizer._instance;
    }

    /*
    Return true if this locale displays numbers with a comma.
    TODO: Base this on the actual user / browser
    */
    useCommaInNumber(): boolean
    {
        return true;
    }

    /*
    Return the symbol for currency in local units.
    This is just a placeholder for now.
    */
    localCurrencyText(): string
    {
        return "USD";
    }

    /*
    Convert some amount of USD into a currency based on the user settings.
    This will need to have an API call or something ahead of time to avoid
    the async/await.  Implementation unknown.  This is a placeholder for now
    */
    convertCurrencyFromUSDToLocal(amount: number): number
    {
        return 0;
    }

}